import { createSlice } from '@reduxjs/toolkit';

import { MAP_REDUCER_NAMES } from '../constants';

import { initialState } from './constants';
import {
  SetCenterCoordsAction,
  SetClusterObjectsAction,
  SetCoordsModeAction,
  SetSettingAction,
  SetShowAimAction,
  SetShowCursorsAction,
  SetShowLabelsAction,
  SetShowObjectIDsAction,
  SetShowObjectsAction,
  SetTypesAction,
} from './types';

const settingsSlice = createSlice({
  name: MAP_REDUCER_NAMES.SETTINGS,
  initialState: initialState,
  reducers: {
    setTypes(state, action: SetTypesAction) {
      state.types = action.payload;
    },
    updateType(state, action) {
      const { type, field, value } = action.payload;

      state.types = {
        ...state.types,
        [type]: { ...state.types[type], [field]: value },
      };
    },
    setTypeActive(state, action) {
      const currentType = state.types[action.payload];

      if (currentType.type === 'style') {
        if (currentType.active) return;

        for (const key in state.types) {
          if (key !== action.payload && state.types[key].type === 'style') {
            state.types[key].active = false;
          }
        }
      }

      state.types[action.payload].active = !state.types[action.payload].active;
    },
    setCenterCoords(state, action: SetCenterCoordsAction) {
      state.centerCoords = action.payload;
    },
    setCoordsMode(state, action: SetCoordsModeAction) {
      state.coordsMode = action.payload;
    },
    setShowAim(state, action: SetShowAimAction) {
      state.showAim = action.payload;
    },
    setShowCursors(state, action: SetShowCursorsAction) {
      state.showCustomCursors = action.payload;
    },
    setShowLabels(state, action: SetShowLabelsAction) {
      state.showLabels = action.payload;
    },
    setShowObjects(state, action: SetShowObjectsAction) {
      state.showObjects = action.payload;
    },
    setClusterObjects(state, action: SetClusterObjectsAction) {
      state.clusterObjects = action.payload;
    },
    setShowObjectIDs(state, action: SetShowObjectIDsAction) {
      state.showObjectIDs = action.payload;
    },
    setSetting(state, action: SetSettingAction) {
      const { key, value } = action.payload;

      return { ...state, [key]: value };
    },
  },
  extraReducers: (builder) => builder,
});

export const { actions: settingsActions, reducer: settingsReducer } =
  settingsSlice;
